const AvatarInitials = ({ data }) => {
  var firstName = data?.name?.split(" ").slice(0, -1).join(" ");
  var lastName = data?.name?.split(" ").slice(-1).join(" ");
  var initials = firstName.charAt(0) + lastName.charAt(0);
  return <div className="mt-2" style={{ width: '30px', height: '30px', fontSize: '0.8rem' }} id="initials">{initials}</div>;
};

export default AvatarInitials;
